import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import './DemandeCesu.scss';
import { Accordion, AccordionTab } from "primereact/accordion";

import { useDispatch, useSelector } from "react-redux";
import { CesuNoticeInformation } from "./CesuNoticeInformation";
import { FormulaireCesu } from "./FormulaireCesu";
import { getUsagerInfo } from "../../../store/actions/usager";
import {setPac,setFiche, setFullActionSociale} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { ClapService } from "../../../service/ClapService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/DemandeClap.scss";

import { Dialog } from "primereact/dialog";
import LoaderDots from '../fields/LoaderDots';



export const DemandeCesu = () => {

  const createMode = "create";
  const editMode = "edit";

  const { mode } = useParams();

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);

  const [editFormData, setEditFormData] = useState(null);
  const [currentActionSociale, setCurrentActionSociale] = useState({});

  const [disabledForm, disableForm] = useState(true);
  const [showLoading, setShowLoading] = useState(null);
  const [hiddenNoticeButton, hideNoticeButton] = useState(editMode === mode ? true : false);
  const [activeIndex, setActiveIndex] = useState([0]);
  const [hideAccordionCompleter, setHideAccordionCompleter] = useState(editMode === mode ? false : true);

  const [displayBasic, setDisplayBasic] = useState(false);
  const [displayError, setDisplayError] = useState([]);


  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();
  const [enfants, setEnfants] = useState([]);


  const linkService = new LinkProviderService();

  const dispatch = useDispatch();
  const history = useHistory();
  const [dataReady, setDataReady] = useState(false);

  const errors = {
      dod: 1,
      statut: 2,
      qf: 2,
      iban: 3,
      pac: 4,
      exercice:5,
      droits:6,
      siDossierValide:7,
      ibanEntranger:8,
      ibanNomtitulaire:9,
      siContentieux:10,
      siNpai:11
    };

  const [qfWarning, setQfWarning] = useState(false);

    const checkErrors = (ficheAgent, errorList,listEnfants) => {
      if(ficheAgent.siNoFiche && !displayError.includes(errors.siContentieux) ){
          errorList.push(errors.exercice);
      }else if(!ficheAgent.siDodEncours) {

          if((actionSociale.exercice > ficheAgent.exerciceDod) && !displayError.includes(errors.exercice)) { errorList.push(errors.exercice); }
          if((!ficheAgent.droits.prestationSansCr ||
                      ( ['1','2'].includes(user.codePosition) && !['1','3','6','2','7'].includes(user.codeSituationAdministrative)) ||
                      ( ['3','4','5'].includes(user.codePosition) && (!['1','2','3'].includes(user.codeSituationAdministrative))) )  && !displayError.includes(errors.droits)) { errorList.push(errors.droits) }
          if(ficheAgent?.statutDod) {
            if(ficheAgent.statutDod !== '3' && !displayError.includes(errors.statut)) { errorList.push(errors.statut) }
            else if((ficheAgent.quotientFamilial == null) && !displayError.includes(errors.qf)) { setQfWarning(true); }
            else if(!ficheAgent.droits.prestationSansCr && !displayError.includes(errors.droits)) { errorList.push(errors.droits) }
          } else if(!displayError.includes(errors.dod)) {
              errorList.push(errors.dod);
          }
          if(!ficheAgent.siDossierValide && !displayError.includes(errors.siDossierValide)){
              errorList.push(errors.siDossierValide);
          }
          if(((ficheAgent?.codeContentieux && ficheAgent.codeContentieux === "3") || ficheAgent?.siOuvertPourMaladie)&& !displayError.includes(errors.siContentieux)){
              errorList.push(errors.siContentieux);
          }
          if(ficheAgent.siNpai){
            errorList.push(errors.siNpai);
          }
      }else{
        if(((ficheAgent?.codeContentieux && ficheAgent.codeContentieux === "3") || ficheAgent?.siOuvertPourMaladie)&& !displayError.includes(errors.siContentieux)){
          errorList.push(errors.siContentieux);
      }
      }
      if(listEnfants.length === 0){
        errorList.push(errors.pac);
      }
        return errorList;
    };





  if (createMode === mode && (!actionSociale || !actionSociale.cas || !actionSociale.exercice || actionSociale.listActionsSociale.length === 0)) {
    history.push("/choixPeriodecesu/"+actionSociale.cas);
  }

  useEffect(() => {
    if (createMode === mode) {
      fetchDataForCreation();
    } else if (editMode === mode) {
       fetchDataForEdition();
    } else {
      window.location.assign(
        linkService.getRetourEaLoginAgent()
      );
    }

    initActiveIndex();
  }, []);

  useEffect(() => {
    if(createMode === mode) disabledForm ? setActiveIndex([0]) : setActiveIndex([1]);
    if(editMode === mode) setActiveIndex([1]);
  }, [disabledForm,dataReady, mode]);

  const fetchDataForCreation = () => {
    getFicheAgent();
    getCurrentActionSociale();
    setDataReady(true);
  };

  const fetchDataForEdition = () => {
     const as = {
           cas: "",
           exercice: "",
           fiche: "",
           optJustificatif: "",
           iban: "",
           maxVal: 0,
           enfants: [],
           listActionsSociale: [],
         };
     chequeCultureService.getEditDto().then((form) => {
           setEditFormData(form.data);
           as.cas = form.data.codeActionSociale;
           as.exercice = form.data.exercice.toString();

           dispatch(getUsagerInfo()).then((user) => {
               if (user != null && user != undefined) {
                 const bareme = {
                   casCode: as.cas,
                   delegId: user.codeDelegation,
                   exercie: as.exercice,
                   siActif: 1,
                 };


                 actionSocialeService.getActionSocialeDematByCASAndDlg(as.cas, user.codeDelegation).then((asList) => {
                     Object.values(asList.data).map((item) => {
                       as.listActionsSociale.push(item);
                       if (item.codeActionSociale === as.cas && item.exercice === as.exercice) {
                         setCurrentActionSociale(item);
                       }
                     });

                    if((mode == editMode && asList.data.length == 0)){
                                        let defaultActionSocial={codeActionSociale: as.cas,codeLibelle: "CESU GARDE D'ENFANTS",
                                        dateDebut: as.exercice,dateFin: as.exercice,codeDelegation: user.codeDelegation ,exercice: as.exercice,defaultEditMode:true
                                        }
                                        as.listActionsSociale.push(defaultActionSocial);
                                        setCurrentActionSociale(defaultActionSocial);
                    }


                     agentService.getFicheAgent(user.numCgos, as.exercice).then((fiche) => {
                         as.fiche = fiche.data;
                         getEnfants(fiche.data);
                         dispatch(setFullActionSociale(as));
                         setDataReady(true);
                         });
                     });



               } else {
                 window.location(
                   linkService.getRetourEaLoginAgent()
                 );
               }
             },
             (error) => {
               window.location(linkService.getRetourEaLoginAgent());
             }
           );
         });

  };

  useEffect(() => {
    dispatch(setPac(enfants));
  }, [enfants]);


  const checkErrorsAndDisplay =  (fiche, listEnfants) => {
    let errorList = [];
    errorList = checkErrors(fiche, errorList,listEnfants);
    setDisplayError(errorList);
};
  
  const getFicheAgent = () => {
      setShowLoading(true);
     try {
        agentService.getFicheAgent(user.numCgos, actionSociale.exercice).then((res) => {
          dispatch(setFiche(res.data));
          getEnfants(res.data);
          setShowLoading(false);
        });
     } catch (error) {
           setShowLoading(false);
            if(!displayError.includes(errors.siContentieux) ){
                  displayError.push(errors.exercice);
            }
     }
  };

  const getEnfants = (fiche)=> {
    agentService
    .getAgentEnfants(user.numCgos, user.codeDelegation, actionSociale.cas, actionSociale.exercice)
    .then((enfants) => {
      let items = [];
      enfants.data.forEach((e) => items.push(e));
      currentActionSociale.enfants = items;
      setEnfants(items);
      if(createMode === mode ){
        checkErrorsAndDisplay(fiche,items);
      }
      
    });
  }


  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (as.codeActionSociale === actionSociale.cas && as.exercice === actionSociale.exercice) {
        setCurrentActionSociale(as);
        return;
      }
    });
  };


  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  const checkDateisValid = (date) => {
       return new Date(date) instanceof Date && !isNaN(new Date(date));
  };

  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([0]);
    if(editMode === mode) setActiveIndex([1]);
  };

  const handleConfirm = (e) => {
    disableForm(e);
    hideNoticeButton(!e);
    setHideAccordionCompleter(false);
  };


  return (
    <div className="grid cld-width">
          <ChequeCultureLegacy />
          <div className="col-12 mx-auto">
            <div
              className="no_shadow_no_border card "
              style={{ display: !displayBasic ? "block" : "none"}}
            >
              <nav aria-label="breadcrumb" class="pt-3">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a
                      href={linkService.getRetourEaAccueilAgent()}
                      target="_self"
                    >
                      Espace Agent
                    </a>
                  </li>

                  <li class="breadcrumb-item">
                    <a
                      href={linkService.getRetourEaMembrePrestation()}
                      target="_self"
                    >
                      Prestations et Formulaires
                    </a>
                  </li>

                  <li aria-current="page" class="breadcrumb-item active">
                    Demande de prestation
                  </li>
                </ol>
              </nav>
              <p></p>
              {currentActionSociale && (
                <div style={{marginBottom: '2%'}}>
                  <h1 style={{ color: "#676767", fontWeight: 300 }}>
                    Prestation {currentActionSociale.exercice}
                  </h1>
                  <h1 style={{ color: "#676767", fontWeight: 100 }}>
                    {currentActionSociale.codeLibelle}
                  </h1>
                  {(createMode === mode ) && checkDateisValid(currentActionSociale.dateFin) && !currentActionSociale?.defaultEditMode &&
                                <h4>
                                  <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                    Demande de prestation possible jusqu'au {" "}
                                    {getDateFormat(currentActionSociale.dateFin)}
                                  </span>
                                </h4>}
                  {(createMode === mode ) && !checkDateisValid(currentActionSociale.dateFin) &&
                    <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                  <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                  Ce formulaire de demande de prestation n’est plus disponible</span>
                    </div>}
                    {(displayError.includes(errors.siContentieux) ) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b>
                           <p>Adressez-vous à la délégation C.G.O.S de votre région pour en savoir plus. <a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank">Nous contacter</a>.</p>
                        </div>
                    )}
                    {(displayError.includes(errors.pac)) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b>
                           <p>Il n’y a pas d’enfants enregistrés ou éligibles dans votre dossier C.G.O.S de l’année concernée. S’il s’agit d’une erreur, adressez-vous à votre contact C.G.O.S.</p>
                        </div>
                    )}
                    {(displayError.includes(errors.siNpai)) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b>
                           <p>Vous devez d'abord mettre à jour votre adresse postale depuis la rubrique <a  href={linkService.getRetourEaMesInfo()} target="_blank">Mes infos &gt; Données personnelles.</a></p>
                         </div>
                    )}
                    {actionSociale.fiche.siDodEncours && (!displayError.includes(errors.siContentieux) ) && (
                         <div class="astuce-box-warning top-msg-resize">
                            <b>Vos droits ne sont pas encore ouverts.</b>
                            <p>Vous pouvez quand même envoyer une demande dès maintenant. <b>Elle sera examinée après l’ouverture de vos droits</b>. Si des ajustements sont nécessaires, le C.G.O.S vous demandera de mettre à jour votre demande.</p>
                         </div>
                    )}
                    {(displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide) ) && (
                        <div class="astuce-box-error top-msg-resize">
                           <b>Vous ne pouvez pas accéder au formulaire de cette prestation pour le moment.</b><br/>
                           Vous devez dabord actualiser votre dossier depuis la rubrique Dossier C.G.O.S en ligne. Pour en savoir plus ou si vous pensez qu’il y a une erreur,  <a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank">adressez-vous à votre Contact C.G.O.S.</a>
                        </div>
                    )}
                    {qfWarning  && (
                        <div class="astuce-box-warning top-msg-resize">
                           <b>Vous n'avez pas communiqué vos revenus. La prestation du C.G.O.S sera minimale.</b><br/>
                           Conformément à votre choix, cette prestation sera calculée sans tenir compte de vos revenus. Si vous souhaitez transmettre votre avis d'imposition, allez à la rubrique  <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank">Prévenir d’un changement de situation</a>.
                        </div>
                    )}

                </div>
              )}
              {((actionSociale?.listActionsSociale?.length > 0 && actionSociale?.fiche) || (editMode === mode)) &&
                <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} role="tablist">
                   <AccordionTab headerClassName="cgos-h2" header="COMPRENDRE LA PRESTATION">
                    <CesuNoticeInformation mode={mode} hiddenNoticeButton={hiddenNoticeButton} onConfirm={(e) => handleConfirm(e)} displayErrors={displayError} />
                  </AccordionTab>

                  <AccordionTab headerClassName="cgos-h2" header={ createMode === mode ? "COMPLETER LA DEMANDE DE PRESTATION" : "COMPLETER VOTRE DEMANDE" } disabled={true} style={{display: hideAccordionCompleter ?  "none":"block" }}>
                  {dataReady && <FormulaireCesu mode={mode} oldForm={editFormData} />}
                  </AccordionTab> 
                </Accordion>
              }

                <Dialog closable={false} header="" visible={showLoading} modal>
                     <div className="loader">
                          <div className="loader-msg">Traitement en cours, merci de patienter</div>
                          <div className="form-row-separator-10"></div>
                          <LoaderDots />
                     </div>
                </Dialog>
            </div>
          </div>
        </div>
      );
};
